import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { LayoutModule } from '../../../layouts/layout.module';
import { IncomeRoutingModule } from './incomes-routing.module';
import { IncomeListComponent } from './income-list/income-list.component';
import { IncomeNewComponent } from './income-new/income-new.component';
/*
import { IncomeDetailComponent } from './income-detail/income-detail.component';
*/
import { IncomeEditComponent } from './income-edit/income-edit.component';

import { MoneyModule } from '../common/money-module';
import { ActionButtonModule } from '../../../../shared/action-button';
import { LiveSearchSelectModule } from '../../../../shared/live-search-select';
import { DatePickerModule } from './../../../../shared/date-picker';
import { ContainerModule } from './../../../../shared/container';
import { ListContainerModule } from './../../../../shared/list-container';
import { IncomeProviders } from '../../../../_models';

@NgModule({
    imports: [
        CommonModule,
        LayoutModule,
        IncomeRoutingModule,
        ActionButtonModule,
        LiveSearchSelectModule,
        DatePickerModule,
        FormsModule,
        ReactiveFormsModule,
        ContainerModule,
        ListContainerModule,
        MoneyModule
    ],
    declarations: [
        IncomeListComponent,
        IncomeNewComponent,
        /*
        IncomeDetailComponent,
        */
        IncomeEditComponent,
    ],
    providers: [
        IncomeProviders
    ]
})
export class IncomesModule { }




// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/incomes/incomes.module.ts